import { Box, Typography, IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

/**
 * InfoField - Reusable label/value pair for detail pages
 * Supports optional edit button and custom value render
 */
const InfoField = ({
  label,
  value,
  onEdit,
  showEdit = false,
  children,
  labelWidth,
  compact = false,
  valueWeight = 600,
}) => {
  const effectiveLabelWidth = labelWidth ?? (compact ? 150 : 200);
  const mobileLabelWidth = compact ? 85 : 95;
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: { xs: 1, sm: compact ? 1.5 : 2 },
        mb: compact ? 0.75 : 2,
        minWidth: 0,
      }}
    >
      <Typography
        variant="body2"
        sx={{
          flex: { xs: `0 0 ${mobileLabelWidth}px`, sm: `0 0 ${effectiveLabelWidth}px` },
          minWidth: { xs: mobileLabelWidth, sm: effectiveLabelWidth },
          flexShrink: 0,
          color: "grey.600",
          fontSize: { xs: 12, sm: 13 },
          fontWeight: 400,
          display: "flex",
          alignItems: "center",
          lineHeight: 1.5,
        }}
      >
        {label}
        {showEdit && onEdit && (
          <IconButton size="small" onClick={onEdit} sx={{ p: 0, ml: 0.5 }}>
            <EditIcon sx={{ fontSize: 18 }} />
          </IconButton>
        )}
      </Typography>
      <Box
        sx={{
          flex: 1,
          minWidth: 0,
          fontSize: { xs: 13, sm: 14 },
          fontWeight: valueWeight,
          color: "text.primary",
          lineHeight: 1.5,
          whiteSpace: "nowrap",
          overflowX: "auto",
          "&::-webkit-scrollbar": { height: 4 },
          "&::-webkit-scrollbar-thumb": { backgroundColor: "rgba(0,0,0,0.2)", borderRadius: 2 },
        }}
      >
        {children !== undefined ? children : value}
      </Box>
    </Box>
  );
};

export default InfoField;
